module.exports = __webpack_public_path__ + "static/media/email_grey.9699874d.svg";